<script>
import { required } from "vuelidate/lib/validators";
import Multiselect from "vue-multiselect";
import Swal from "sweetalert2";

// Custom Components
import PageHeader from "@/components/page-header";
// import Pagination from "@/components/Pagination.vue";
import TicketService from "@/helpers/APIService/ticket.service";
import { authComputed } from "@/state/helpers";
import appConfig from "@/app.config";
import errorHandler from "@/helpers/errorHandler";
import middlewares from "@/helpers/middlewares";

export default {
  page: {
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    PageHeader,
    // Pagination,
    Multiselect,
  },
  data() {
    return {
      title: "PBX Ticket Title",
      priority_option: [
        {
          text: "Normal",
          value: "normal",
        },
        {
          text: "High",
          value: "high",
        },
        {
          text: "Urgent",
          value: "urgent",
        },
      ],
      table: {
        tableData: [],
        totalPages: 1,
        pageNumber: 1,
        size: 50,
      },
      ticket_title: "",
      ticket_priority: {
        text: "Normal",
        value: "normal",
      },
      ticket_title_id: null,
      edit_index: null,
      submitted: false,
      isBtnLoading: false,
      isError: false,
      errorMessage: null,
      pbxTicketTitleId: null,
      isLoading: false,
      isEdit: false,
    };
  },
  validations: {
    ticket_title: { required },
  },
  computed: {
    ...authComputed,
  },
  mounted() {
    this.getTicketTitleList();
  },
  methods: {
    // Method is used to get title list
    async getTicketTitleList() {
      try {
        this.isLoading = true;
        const response = await TicketService.getTicketTitleList();
        if (response.status == false) {
          return middlewares.notification(response.message, "warning");
        }
        this.table.tableData = response.result;
        this.table.pageNumber = response.page_number;
        this.table.totalPages = response.count;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        errorHandler(error);
      }
    },
    // Method is used to handle pagination
    onPageChange(page) {
      this.getPhoneNumberList(
        `?page_number=${page}&page_size=${this.table.size}`
      );
    },
    // Method is used to edit form
    pbxTicketTitleForm() {
      this.ticket_title = '';
      this.ticket_priority= {
        text: "Normal",
        value: "normal",
      };
      this.ticket_title_id= null,

      this.$bvModal.show("ticket-title");

    },
    // Method is used to handle edit pbx ticket title
    editTicketTitle(data, index) {
      this.ticket_title = data.title;
      this.ticket_priority = this.priority_option.find(
        (item) => item.value == data.priority
      );
      this.ticket_title_id = data.id;
      this.edit_index = index;
      this.$bvModal.show("ticket-title");
      this.isEdit = true;
    },
    // Method is used to cancel form submission
    handleCancel() {
      this.isEdit = false;
      this.$bvModal.hide("ticket-title");
    },
    // Method is used to handle submit of form
    onSubmit() {
      this.submitted = true;
      this.isBtnLoading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.isBtnLoading = false;
      } else {
        if (this.isEdit) {
          TicketService.updateTicketTitleDetail(this.ticket_title_id, {
            title: this.ticket_title,
            priority: this.ticket_priority.value,
          })
            .then((response) => {
              if (response.status == false) {
                return middlewares.notification(response.message, "warning");
              }
              middlewares.notification(
                "Title updated successfully !!",
                "success"
              );
              this.$set(this.table.tableData, this.edit_index, response.result);
              this.$bvModal.hide("ticket-title");
              this.isBtnLoading = false;
              this.edit_index = null;
              this.ticket_title_id = null;
              this.isEdit = false;
            })
            .catch((error) => {
              this.isBtnLoading = false;
              this.isError = true;
              this.errorMessage = error.response.data;
              errorHandler(error);
            });
        } else {
          TicketService.createTicketTitle({
            title: this.ticket_title,
            priority: this.ticket_priority.value,
          })
            .then((response) => {
              if (response.status == false) {
                return middlewares.notification(response.message, "warning");
              }
              middlewares.notification(
                "Title added successfully !!",
                "success"
              );
              this.table.tableData.push(response.result);
              this.isBtnLoading = false;
              this.$bvModal.hide("ticket-title");
            })
            .catch((error) => {
              this.isBtnLoading = false;
              this.isError = true;
              this.errorMessage = error.response.data;
              errorHandler(error);
            });
        }
      }
    },
    // Method is used to delete ticket title
    deletePbxticket(ticket_title_id, index) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          TicketService.deleteTicketTitle(ticket_title_id)
            .then(() => {
              this.table.tableData.splice(index, 1);
              middlewares.notification(
                "Record deleted successfully !!",
                "danger"
              );
              this.isLoading = false;
            })
            .catch((error) => {
              errorHandler(error);
            });
        }
      });
    },
  },
};
</script>

<template>
  <div>
    <PageHeader
      :title="title"
      :action="pbxTicketTitleForm"
      text="Add New Ticket Title"
      :isButton="true"
    />
    <b-card>
      <div class="table-responsive">
        <table class="table mb-0">
          <thead class="table-light" slot="head">
            <tr>
              <th>Pbx Ticket Title</th>
              <th>Priority</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody v-if="isLoading">
            <tr v-for="item in 20" :key="item">
              <td class="placeholder-glow" v-for="no in 3" :key="no">
                <span class="placeholder w-100 placeholder-lg"></span>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr v-for="(ticket, index) in table.tableData" :key="index">
              <td @click="editTicketTitle(ticket, index)">
                {{ ticket.title }}
              </td>
              <td @click="editTicketTitle(ticket, index)">
                <span
                  class="badge align-items-center py-1 px-2 card-badge text-capitalize"
                  :class="[
                    ticket.priority === 'high'
                      ? 'badge-soft-warning'
                      : ticket.priority === 'urgent'
                      ? 'badge-soft-danger'
                      : ticket.priority === 'normal'
                      ? 'badge-soft-primary'
                      : 'badge-soft-secondary',
                  ]"
                >
                  {{ ticket.priority }}
                </span>
              </td>
              <td>
                <i
                  class="fas fa-pencil-alt text-success"
                  v-b-popover.hover="'Edit'"
                  @click="editTicketTitle(ticket, index)"
                ></i>
                <i
                  class="mdi mdi-trash-can ms-2 fs-5 text-danger"
                  v-b-popover.hover="'Delete'"
                  @click="deletePbxticket(ticket.id, index)"
                ></i>
              </td>
            </tr>
          </tbody>
          <tbody v-if="!isLoading && table.tableData.length == 0">
            <tr>
              <td colspan="9" class="text-center">
                <img src="@/assets/images/empty.svg" class="img-fluid" alt="" />
                <p>
                  <span class="text-secondary">No Data Found</span>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- <Pagination
          v-if="table.tableData.length !== 0"
          :totalPages="table.totalPages"
          :currentPage="table.pageNumber"
          @pagechanged="onPageChange"
        /> -->
      </div>
    </b-card>

    <!-- Modal is used to open pbx ticket form -->
    <b-modal
      id="ticket-title"
      centered
      :title="`${isEdit ? 'Update' : 'Add New'}Ticket Title`"
      hide-footer
      title-class="font-18"
      @hidden="handleCancel"
    >
      <div class="row">
        <div class="col-md-12">
          <b-form-group class="mb-3" label-for="caller_name">
            <span slot="label"> Title <span class="text-danger">*</span> </span>
            <b-form-input
              id="title"
              type="text"
              autocomplete="off"
              v-model="ticket_title"
              :class="{
                'is-invalid': submitted && $v.ticket_title.$error,
              }"
            ></b-form-input>
            <div v-if="submitted" class="invalid-feedback">
              <span v-if="!$v.ticket_title.required">Title is required.</span>
            </div>
          </b-form-group>
        </div>
        <div class="col-md-12">
          <b-form-group class="mb-3" label-for="priority">
            <span slot="label">Priority</span>
            <multiselect
              v-model="ticket_priority"
              :options="priority_option"
              :show-labels="false"
              label="text"
              track-by="value"
              id="select-priority"
            ></multiselect>
          </b-form-group>
        </div>
        <div class="col-md-12">
          <b-alert v-if="isError" show variant="danger">
            <ul>
              <li v-for="(error, index) in errorMessage" :key="index">
                {{ index }}: {{ error[0] }}
              </li>
            </ul>
          </b-alert>
        </div>

        <div class="col-md-12">
          <b-button
            class="float-end ms-2"
            variant="outline-primary"
            type="reset"
            @click="handleCancel"
            >Cancel</b-button
          >
          <b-button
            class="float-end"
            variant="outline-primary"
            type="submit"
            @click="onSubmit"
            :class="{
              disabled: isBtnLoading,
            }"
          >
            <i
              class="bx bx-loader bx-spin font-size-16 align-middle me-2"
              v-if="isBtnLoading"
            ></i>
            {{ isEdit ? "Update" : "Save" }}
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
